module.exports = __webpack_public_path__ + "img/dental-hygiene.3d73a2a5.png";